document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pc-careers]').forEach((section) => {
    const form = section.querySelector('.pc-careers__application');
    const select = section.querySelector('[data-career-position-select]');

    section.querySelectorAll('[data-career-position]').forEach((button) => {
      button.addEventListener('click', () => {
        if (select) select.value = button.dataset.careerPosition || '';
        form?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => select?.focus({ preventScroll: true }), 500);
      });
    });
  });
});
